const INITIAL_FILTERS = {
    activity: null,
    appId: null,
    countable: null,
    cohortType: 'visitor',
    cohortSize: 'month',
    account: {
        text: 'All Accounts',
        id: '',
        className: 'account-chooser-all-accounts',
    },
    periodCount: 6,
    segmentId: null,
    periodStart: null,
    periodEnd: null,
};

export const defaultFilterState = {
    lastEdited: null,
    lastSent: null,
    activity: {
        value: null,
        valid: false,
        errMessage: null,
    },
    app: {
        value: {
            id: INITIAL_FILTERS.appId,
        },
        valid: true,
        errMessage: null,
    },
    countable: {
        value: INITIAL_FILTERS.countable,
        valid: true,
        errMessage: null,
    },
    cohortType: {
        value: INITIAL_FILTERS.cohortType,
        valid: true,
        errMessage: null,
    },
    cohortSize: {
        value: INITIAL_FILTERS.cohortSize,
        valid: true,
        errMessage: null,
    },
    periodCount: {
        value: INITIAL_FILTERS.periodCount,
        valid: true,
        errMessage: null,
    },
    periodStart: {
        value: INITIAL_FILTERS.periodStart,
        valid: true,
        errMessage: null,
    },
    periodEnd: {
        value: INITIAL_FILTERS.periodEnd,
        valid: true,
        errMessage: null,
    },
    segment: {
        value: {
            id: INITIAL_FILTERS.segmentId,
        },
        valid: true,
        errMessage: null,
    },
    account: {
        value: INITIAL_FILTERS.account,
        valid: false,
        errMessage: null,
    },
};

export const INITIAL_CHART_SELECTIONS = Object.freeze({
    showDataLabels: 'all',
    chartPeriodSelection: 1,
    breakdownSelection: 'cohort',
    benchmarks: {
        showBenchmarks: true,
        companySize: 'all',
        industry: 'all',
        include: ['median'],
    },
});

export default INITIAL_FILTERS;
